import { ItalicExtension as RemirrorItalicExtension } from 'remirror/extensions'
import { markInputRule } from '@remirror/core'

class ItalicExtension extends RemirrorItalicExtension {
  // Added shouldSkip logic
  // valid cases *test*, __test__, *hello world*
  // invalid cases * test *, _ test _, *test *
  // https://github.com/remirror/remirror/blob/%40remirror/react%402.0.35/packages/remirror__extension-italic/src/italic-extension.ts#L57
  createInputRules() {
    return [
      markInputRule({
        regexp: /(?:^|[^*])\*([^*]+)\*$/,
        type: this.type,
        ignoreWhitespace: true,
        updateCaptured: ({ fullMatch, start }) =>
          !fullMatch.startsWith('*')
            ? { fullMatch: fullMatch.slice(1), start: start + 1 }
            : {},
        shouldSkip: ({ captureGroup }) => {
          if (captureGroup?.trim().length !== captureGroup?.length) return true
          return false
        },
      }),
      markInputRule({
        regexp: /(?:^|\W)_([^_]+)_$/,
        type: this.type,
        ignoreWhitespace: true,
        updateCaptured: ({ fullMatch, start }) =>
          !fullMatch.startsWith('_')
            ? { fullMatch: fullMatch.slice(1), start: start + 1 }
            : {},
        shouldSkip: ({ captureGroup }) => {
          if (captureGroup?.trim().length !== captureGroup?.length) return true
          return false
        },
      }),
    ]
  }
}

export default ItalicExtension
